<template>
  <div v-if="status" class="swal2-container swal2-fade swal2-shown" style="overflow-y: auto; ">
    <div aria-labelledby="swal2-title" aria-describedby="swal2-content" class="swal2-popup swal2-modal swal2-show swal2-payment"
         tabindex="-1" role="dialog" aria-live="assertive" aria-modal="true" style="display: flex; width: 560px;" ref="modal">
      <div class="swal2-header">
        <h2 class="swal2-title" id="swal2-title" style="display: flex;">{{ $t('messages.payment.title') }}</h2>
        <button type="button" class="swal2-close" @click="close">×</button>
      </div>

      <div style="-webkit-overflow-scrolling: touch; margin: 5px">

        <div class="block" v-if="!paymentURL.length">
          <div class="input-group" style="height: 54px;">
            <input name="number" v-model="value" class="number" type="text" style="height: 54px;"/>
            <div class="input-group-addon" style="background: #fff;border: none;font-size: 28px;">{{ type.usd ? '$' : ($parent.site === 'likemania.kz' ? '₸' : '₽') }}</div>
            <span class="input-group-btn">
                <a v-ripple @click="pay" class="btn btn-info" style="height: 100%;line-height: 54px;padding: 0px 10px; background: #FCD130; color: #000; text-shadow: none;">{{ $t('messages.payment.order') }}</a>
            </span>
          </div>

          <div style="text-align: center; margin-top: 5px; margin-bottom: 10px;" :class="{ 'has-success': promo_status === true, 'has-error': promo_status === false }">
            <a href="#" class="promo" @click.prevent="promo_show = !promo_show">{{ $t('messages.payment.promo_button') }} <icon :name="promo_show ? 'caret-up' : 'caret-down'" scale="1"></icon></a>

            <div v-show="promo_show">
              <input style="margin-top: 10px; height: 54px; margin-bottom: 10px;padding-left: 10px;font-size: 15px;" :placeholder="$t('messages.payment.promo_placeholder')" name="promo" v-model="promo" type="text"/>
              <p style="text-align: left; min-height: 10px; margin-top: 5px;">{{ promo_status !== null ? $t(promo_status ? 'messages.payment.promo_success' : 'messages.payment.promo_error', {proc: promo_number}) : '' }}</p>
            </div>
          </div>

          <div class="clearfix"></div>

          <div class="gblock" v-html="$t('messages.payment.cantpay')">

          </div>

          <transition name="list">
            <div class="block" v-if="type.id === 10 || type.id === 7">
              <input name="phone" v-model="phone" style="height: 45px;" class="form-control" type="text" :placeholder="$t('messages.payment.phone')"/>
            </div>
          </transition>

          <h3 v-if="false">{{ $t('messages.payment.payin1') }}</h3>


          <div class="row">
            <div @click="type=item" :class="{ current: type===item }" class="col-lg-6 payment-type" v-bind:key="item.id" v-for="item in $parent.payments.filter(item => item.usd !== !lang && item.hide !== lang + 1)">
              <input type="radio" :id="'payment' + item.id" name="type" :checked="item.id == type.id"/>
                <label :for="'payment' + item.id"><span><span></span></span><icon scale="1.7" :name="'pay/' + item.icon"></icon>
                    {{ item.name }}
                </label>
            </div>
          </div>

          <h3 v-if="$parent.lang === 'ru' && false">{{ $t('messages.payment.payin2') }}</h3>

          <div class="row" v-if="$parent.lang === 'ru' && false">
            <div @click="type=item"  :class="{ current: type===item }" class="col-lg-6 payment-type" v-bind:key="item.id" v-for="item in $parent.payments.filter(item => item.usd === !lang && item.hide !== lang + 1)">
              <input type="radio" :id="'payment' + item.id" name="type" :checked="item.id == type.id"/>
                <label :for="'payment' + item.id"><span><span></span></span><icon scale="1.7" :name="'pay/' + item.icon"></icon>
                    {{ item.name }}
                </label>
            </div>
          </div>
          <div class="clearfix"></div>
        </div>

        <div class="swal2-actions" style="display: flex; margin-bottom: 10px;">
          <a v-if="paymentURL.length" type="button" @click="all" class="promo" aria-label="">{{ $t('messages.payment.all') }}
            <icon name="undo" scale="0.7"></icon>
          </a>
        </div>

        <div v-if="paymentURL.length && payed" style="display: block; padding: 30px; background: rgb(175, 236, 193); margin-bottom: 20px;">{{ $t('messages.payment.success') }} <icon name="check-circle" scale="1"></icon></div>

        <div v-if="paymentURL.length && !payed" style="display: block; text-align: center; padding: 30px; background: rgb(229, 230, 255); margin-bottom: 20px;">{{ $t('messages.payment.wait') }} <icon name="sync" :spin="true" scale="1"></icon></div>

        <div class="iframe-wrapper" v-if="paymentURL.length && iframe && !payed">
          <vue-friendly-iframe :src="paymentURL" @load="onLoad"></vue-friendly-iframe>
        </div>

        <a v-if="paymentURL.length && !iframe && !payed" :href="paymentURL" target="_blank" class="btn btn-info btn-block" style="padding: 40px; background: #485291; display: block;">{{ $t('messages.payment.go') }} <i class="icon-share-alt"></i></a>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueFriendlyIframe from 'vue-friendly-iframe';

Vue.use(VueFriendlyIframe);

export default {
  name: 'PaymentModal',
  props: {
    showed: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    },
  },
  data: function () {
    return {
      status: false,
      type: {},
      value: 100,
      phone: '',
      event: null,

      promo: '',
      promo_show: false,
      promo_status: null,
      promo_number: 0,
      previousRequest: null,

      step: 1,
      min: 1,
      max: 100000,
      order_id: 0,
      order_type: '',
      paymentURL: '',
      id: 0,
      payed: false,
      full: false,
      eventpay: null,
      iframe: false,
    }
  },
  computed: {
    first() {
      return this.$parent.lang === 'ru' ? this.$parent.payments[0] : this.$parent.payments.filter(item => item.usd)[0];
    },
    lang() {
      return Number(this.$parent.lang !== 'ru')
    }
  },
  watch: {
    type: function () {
      this.value = Math.min(
          Math.max(
              isNaN(this.value) ? 0 : this.value,
              this.type.min !== 0 ? this.type.min : this.min
          ),
          this.type.max !== 0 ? this.type.max : this.max
      )
    },
    value: function (value, prev) {
      var self = this;

      let val = Math.min(
          Math.max(
              isNaN(value) ? 0 : value,
              this.type.min !== 0 ? this.type.min : this.min
          ),
          this.type.max !== 0 ? this.type.max : this.max
      )

      if (val !== prev) {
        clearTimeout(this.event);

        this.event = setTimeout(function () {
          self.value = val;
        }, 1000);
      }
    },
    showed: function (value) {
      if(!value)
      {
        this.close();
      }
    },
    promo: function () {
      if(this.promo.length > 2)
      {
        this.$http.jsonp('promo', {
          params: { key: this.$parent.key, code: this.promo, is_api: 0, is_app: this.$parent.is_app },
          before(request) {
            this.promo_status = null;
            if (this.previousRequest) {
              this.previousRequest.abort();
            }
            this.previousRequest = request;
          }
        }).then(function(response){
          this.promo_status = response.body.status;
          if(this.promo_status)
          {
            this.promo_number = response.body.number;
          }
        }, function () {

        });
      }
      else
      {
        this.promo_status = null;
      }
    }
  },
  created: function () {
    this.type = this.first;
  },
  beforeDestroy: function(){
    //this.close();
  },
  methods: {
    pay : function () {
      var self = this;

      this.iframe = this.type.iframe;

      this.$http.jsonp('payment', {
        params: {
          key: this.$parent.key,
          number: this.value * (this.$parent.site === 'likemania.kz' && !this.type.usd ? ([58, 59].includes(this.type.id) ? 1 / window.settings.c: window.settings.c) : 1),
          type: this.type.id, usd: +(this.$parent.lang === 'en' && this.type.usd),
          order_id : this.order_id,
          order_type: this.order_type,
          promo: this.promo,
          is_api: 0, is_app: this.$parent.is_app
        }
      }).then(function(response){

        if(!this.status)
        {
          this.status = true;
        }

        this.id = response.body.id;
        this.paymentURL = Vue.http.options.root.replace('/api2/', '') + '/payment?id=' + response.body.id + '&phone=' + this.phone;

        if([49, 50, 58, 59].includes(this.type.id)) {
          this.paymentURL = 'https://likemania.kz/payment?id=' + response.body.id + '&phone=' + this.phone;
        }

        if(!this.iframe)
        {
          window.open(this.paymentURL, '_blank')
        }

        clearTimeout(this.eventpay);

        this.eventpay = setInterval(function () {
          self.$http.jsonp('payment', { params: { key: self.$parent.key, id: self.id } }).then(function(payment){
            if(payment.body.status)
            {
              self.payed = true;
              clearTimeout(self.eventpay);
            }
          });
        }, 1000);
      }, function () {
        this.$swal({
          title: this.$t('messages.alerts.error'),
          text: this.$t('messages.alerts.servererror'),
          icon: 'error',
        });
      });
    },
    show: function (full) {
      if(this.$parent.is_app)
      {
        this.$parent.tab = 3;
      }

      let that = this
      this.full = full || false;
      this.status = true;
      this.type = this.first;
      this.id = '';
      this.paymentURL = '';
      this.order_id = 0;
      this.order_type = '';
      clearTimeout(this.eventpay);

      let handle = (event) => event.target.contains(that.$refs.modal) && that.close() && document.removeEventListener('click', handle);

      document.addEventListener('click', handle);
    },
    close: function (e) {
      this.status = false;
      this.type = this.first;
      this.id = '';
      this.paymentURL = '';
      this.order_id = 0;
      this.order_type = '';
      this.$parent.updateBalance();
      this.$parent.$refs.tasks.getPage();
      clearTimeout(this.eventpay);
      return true
    },
    all: function () {
      this.id = '';
      this.paymentURL = '';
      clearTimeout(this.eventpay);
    }
  }
}
</script>

<style scoped>
h3 {
  font-size: 18px;
  font-weight: bold;
}

hr {
  margin: 0;
}

.number {
  padding-left: 10px;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  font-size: 18px;
}

.gblock {
  background: #DEEAFF;
  color: #485291;
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-size: 12px;
  margin-bottom: 10px;
}
</style>